import React from 'react';
import PropTypes from 'prop-types';
import DocumentClaimsChunk from '@Components/Results/documents/DocumentClaimsChunk';

function DocumentClaims({ closeClick, claimsText }) {
  return (
    <div className="result-detail-panel u-els-margin-top-1o2">
      <div className="result-detail-panel-wrapper">
        <h4 className="u-els-margin-bottom-1o2">Claims</h4>
        <div className="result-detail-block u-els-font-size-base u-els-line-height-default">
          <DocumentClaimsChunk chunk={claimsText} />
        </div>
        <button type="button" tabIndex={0} className="els-btn els-btn-modal-close e2e-close" onClick={closeClick} aria-label="Close claims">
          <svg className="els-btn-icon els-btn-icon-tiny">
            <use xlinkHref="#icon-delete" />
          </svg>
        </button>
      </div>
    </div>
  );
}

DocumentClaims.propTypes = {
  claimsText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentClaims;
